<template>
 <div class="card-primary">

            <p class="text-xxxl text-bold">Open Issues</p>

            <div class="row mt-20">
              <div class="col-12 text-bold">
                <div class="card-primary-scroll-small">
                  <div class="card-issues" v-for="issueProject in issue" :key="issueProject.id">
                    <div class="" v-if="issueProject.closed_on == null ">
                        <div v-bind:class="'card-'+issueProject.priority.name.toLowerCase()">
                          <div class="row">
                            <div class="col-1" v-bind:class="'icon-'+issueProject.priority.name.toLowerCase()">
                              <i class="fas fa-angle-down fa-2x" v-if="issueProject.priority.name.toLowerCase() == 'low'"></i>
                              <i class="fas fa-grip-lines fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'normal'"></i>
                              <i class="fas fa-angle-up fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'high'"></i>
                              <i class="fas fa-angle-double-up fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'urgent'"></i>
                              <i class="fas fa-caret-square-up fa-2x" v-else></i>
                            </div>
                            <div class="col-2 text-m text-bold">{{issueProject.tracker.name}}</div>
                            <div class="col-6">
                              <p class="text-m text-bold">{{ issueProject.subject}}</p>
                            </div>
                            <div class="col-3">
                              <p class="text-m text-bold">{{issueProject.project.name}}</p>
                            </div>
                          </div>

                        </div>
                    
                    </div>
                    
                  </div>
                </div>

              </div>
            </div>

          </div>    
</template>

<script>
export default {
    name:"CardOpenIssue",
    props: ['issue']
}
</script>

<style scoped>
  .text-m {
    font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/components/User/CardOpenIssue.vue